import { Box, Button, Card, Grid, makeStyles, Typography } from "@mui/material";
import "../AppMobile.css";
import CardHoverCeci from "./CardHoverCeci";

const Cards = [
    {
        title: "Chinesiologia",
        description: "disciplina terapeutica che utilizza il movimento come strumento di prevenzione, cura e rieducazione funzionale ",
        image: "CardCosaFaremo1.png"
    },
    {
        title: "Ginnastica Posturale",
        description: "insieme di esercizi, movimenti dolci, allungamenti e tecniche di respirazione, studiati per riequilibrare la postura, migliorare la mobilità della colonna vertebrale e ridurre o prevenire dolori",
        Desc02: "muscolo-scheletrici",
        image: "tablet/CardCosaFaremo2.png"
    },
    {
        title: "PERSONAL TRAINING",
        description: "programmi su misura per benessere, rinforzo muscolare e performance. Allenamento funzionale a corpo libero per migliorare la muscolatura e la gestione o il trasporto di carichi",
        image: "CardCosaFaremo3.png"
    }
]



export default function Card3() {
    return (
        <>
            <div className="stile-titolo" style={{ width: '90%', marginLeft: '10%', marginTop: '15vh' }}>COSA FAREMO</div>
            <Box
                sx={{
                    marginLeft: '5%',                    
                    marginTop: "20px",
                    display: "flex",
                    overflowX: "auto",
                    gap: 6,
                    paddingX: 4,
                    paddingY: 2,
                    scrollSnapType: "x mandatory", // scroll “a scatti” se vuoi
                    "&::-webkit-scrollbar": { display: "none" }, // nasconde scroll bar
                    msOverflowStyle: "none",
                    scrollbarWidth: "none",
                }}
            >
                {Cards.map((card, index) => (
                    <Box
                        key={index}
                        sx={{
                            flex: "0 0 auto", // impedisce che si ridimensioni
                            width: "70vw", //{ xs: "80vw", sm: "320px", md: "380px" }, // responsive
                            height: "400px",
                            scrollSnapAlign: "start",
                        }}
                    >
                        <CardHoverCeci Titolo={card.title} Descrizione={card.description} Image={card.image} Desc02={card.Desc02}/>
                    </Box>
                ))}
            </Box>
            <div style={{ height: '7vh' }}></div>
        </>
    );
}